var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66642 0.666504C1.19976 0.666504 -0.000244141 1.8665 -0.000244141 3.33317V7.55984C-0.000244141 8.2665 0.279756 8.9465 0.786423 9.45317L5.33309 13.9998L0.773089 18.5598C0.279756 19.0665 -0.000244141 19.7465 -0.000244141 20.4532V24.6665C-0.000244141 26.1332 1.19976 27.3332 2.66642 27.3332H13.3331C14.7998 27.3332 15.9998 26.1332 15.9998 24.6665V20.4532C15.9998 19.7465 15.7198 19.0665 15.2264 18.5732L10.6664 13.9998L15.2131 9.4665C15.7198 8.95984 15.9998 8.27984 15.9998 7.57317V3.33317C15.9998 1.8665 14.7998 0.666504 13.3331 0.666504H2.66642ZM13.3331 19.9998V23.3332C13.3331 24.0665 12.7331 24.6665 11.9998 24.6665H3.99976C3.26642 24.6665 2.66642 24.0665 2.66642 23.3332V19.9998L7.99976 14.6665L13.3331 19.9998ZM7.99976 13.3332L2.66642 7.99984V4.6665C2.66642 3.93317 3.26642 3.33317 3.99976 3.33317H11.9998C12.7331 3.33317 13.3331 3.93317 13.3331 4.6665V7.99984L7.99976 13.3332Z",
    fill: "#C38236"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.035ba8b4a2c0ca179556211030326106.svg";
export { ForwardRef as ReactComponent };